<template>
  <div class="views-wrapper">
    <Head :title="$tc('header.back')" />
    <!-- <Foot /> -->

    <div class="views-inner" v-if="channelData">
      <h3
        class="page-title"
        v-if="channelData.channel && channelData.channel.name"
      >
        <span>{{ channelData.channel.name }}</span>
      </h3>
      <Banner
        v-if="channelData.banner && channelData.banner.length"
        :banner="channelData.banner"
      />
      <div class="views-list" v-if="list && list.length">
        <news-list :list="list"></news-list>
        <p class="loading-notice">
          {{
            isLoading
              ? $tc("load.loading")
              : lastList.length >= pageSize
              ? $tc("load.more")
              : $tc("load.nomore")
          }}
        </p>
      </div>
    </div>
    <Footer />
    <Empty :emptydata="emptydata" v-if="emptydata" />
  </div>
</template>

<script>
import Banner from '@/components/Channel/Banner.vue'
import NewsList from '@/components/Channel/NewsList.vue'

import { mapMutations } from 'vuex'

export default {
    name: 'Channel',
    data () {
        return {
            id: '',
            channelData: null,
            list: [],
            lastList: [],
            pageSize: 10,
            lastDataId: '',
            isLoading: false,
            emptydata: null
        }
    },
    components: {
        Banner,
        NewsList
    },
    created () {
        this.id = this.$route.params.id
        this.getLatestData()
    },
    mounted () {
        this.$Common.pullLoadData(this.getLatestData)
        this.$nextTick(() => {
            this.$Common.pageShare()
        })
        this.$Common.track('load', {
            name: '精彩回顾',
            id: this.id,
            type: '资讯'
        })
    },
    methods: {
        ...mapMutations(['setShowLoading', 'setToastData']),
        getLatestData () {
            if (
                this.isLoading ||
                (this.lastDataId && this.lastList.length < this.pageSize)
            ) {
                return
            }
            this.isLoading = true
            this.$Api
                .getChannelList({
                    channelId: this.id,
                    pageSize: this.pageSize,
                    lastDataId: this.lastDataId,
                    queryType: this.list.length ? 2 : 1
                })
                .then(data => {
                    if (data) {
                        !this.channelData && (this.channelData = data)
                        this.list.push(...(data.list || []))
                        this.lastList = data.list || []
                        this.lastDataId = data.lastDataId || ''
                    }
                    if (!this.list.length) {
                        this.emptydata = {
                            type: 'nodata'
                        }
                    } else {
                        this.emptydata = null
                    }
                    this.isLoading = false
                    this.setShowLoading(false)
                })
                .catch(() => {
                    if (!this.lastDataId) {
                        this.emptydata = {
                            type: 'nonetwork'
                        }
                    } else {
                        this.setToastData({
                            text: this.$t('default.failed')
                        })
                    }
                    this.isLoading = false
                    this.setShowLoading(false)
                })
        }
    }
}
</script>

<style lang="scss">
.views-wrapper {
  font-size: 0;
  padding-bottom: 13.889vw;
  .empty-wrapper {
    height: 60vh;
  }
}
</style>
